// Transform prose text only: links, inline code and fenced code retain their meaning.
type Node = {
  type: string;
  value?: string;
  children?: Node[];
  data?: { hName: string; hProperties: Record<string, string> };
};
export function remarkMentions() {
  return (tree: Node) => {
    function visit(node: Node) {
      if (
        !node.children ||
        ["link", "linkReference", "code", "inlineCode", "html"].includes(
          node.type,
        )
      )
        return;
      node.children = node.children.flatMap((child) => {
        if (child.type !== "text" || !child.value) {
          visit(child);
          return [child];
        }
        const parts: Node[] = [];
        let offset = 0;
        for (const match of child.value.matchAll(
          /(?<!\S)(?:\/[a-z0-9-]+|@artifact:[a-z0-9](?:[a-z0-9._-]*[a-z0-9_-])?|@[a-z0-9._~/-]*[a-z0-9_~/-])(?=\s|$|[.,!?;:)])/gi,
        )) {
          const index = match.index!;
          parts.push({ type: "text", value: child.value.slice(offset, index) });
          parts.push({
            type: "mention",
            data: {
              hName: "span",
              hProperties: { "data-mention-reference": match[0] },
            },
            children: [{ type: "text", value: match[0] }],
          });
          offset = index + match[0].length;
        }
        parts.push({ type: "text", value: child.value.slice(offset) });
        return parts;
      });
    }
    visit(tree);
  };
}
